
import {createSlice} from "@reduxjs/toolkit";

export const interestSlice = createSlice({
    name: 'interestSlc',
    initialState: {value: {id: null, externalId: null, rateDate: null,
            rate: null, source: null,
            effective_date: null, expired_on: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            interestDrawerState: false, interestDrawerMode: null, interestGridRefresh: false,
            interestUploadState: false
        }},
    reducers:

        {
            changeInterest: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeInterest } = interestSlice.actions;

export default  interestSlice.reducer ;

